'use strict';

intellidealerAppCoreModule.factory('equipmentHistoryResource', function ($resource, appConfigurationService) {
  return {
    assignedEquipmentHistoryByStockNumber: $resource(appConfigurationService.basePath + '/rest/equipmenthistory/assignedEquipmentHistoryByStockNumber')
  }
});
